<script setup lang="ts">
import type { MetaProps } from './lib';

const props = defineProps<MetaProps>();
</script>

<template>
  <div
    class="w-full text-white font-light font-mono p-2"
  >
    <div class="text-center text-[35px] pt-6">
      {{ props.name }}
    </div>
    <div class="text-center text-[22px] pb-6 text-[#a6a9a6]">
      {{ location }}
    </div>
    <div class="flex flex-col text-l justify-center text-center text-[#a6a9a6]">
      <span>{{ $t('nfc.device.updated') }} - {{ props.updated.toLocaleString() }}</span>
      <span>{{ $t('common.serial') }} - {{ props.serial }}</span>
    </div>
  </div>
</template>
